import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import { logScope, init } from 'log-scope'

const log = logScope('🐞')

const devMode = process.env.NODE_ENV === 'development'

const bugsnagHandler = {
  apiKey: '95671a18a92cd47e0ff28b9a2b7eff8a',
}

bugsnagHandler.init = Vue => {
  if (devMode) {
    log.danger('Is localhost, disabling bugsnag.')
    return
  }

  window.bugsnagClient = bugsnag({
    apiKey: bugsnagHandler.apiKey,
    otherOptions: {
      appType: 'equardian-web',
    },
  })
  window.bugsnagClient.use(bugsnagVue, Vue)

  // Send to bugsnag on log.error
  init({
    onError: (err, data) => {
      window.bugsnagClient.notify(err, {
        metaData: data,
      })
    },
  })
}

export default bugsnagHandler
